import clsx from "clsx";
import React from "react";

type Props = {
  children?: React.ReactNode;
  placeholder?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  validation?: boolean;
};

export default function PrimaryButton({
  children,
  className,
  validation,
  ...props
}: Props) {
  return (
    <button
      className={clsx([
        "bg-brand-primary-magenta text-white active:bg-button-primary-hover disabled:opacity-60",

        {
          "bg-brand-neutral-20 text-brand-primary-gray-100 !opacity-30 bg-none active:bg-brand-neutral-20 active:text-brand-primary-gray-100":
            validation,
        },
        className,
      ])}
      {...props}
    >
      {children}
    </button>
  );
}
